import React from 'react';
import { X, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const pains = ['Pasas horas buscando videos o diagramas que no explican todo con claridad.', 'Tienes dudas al interpretar planos, tableros o conexiones.', 'Te cuesta calcular materiales y presupuestos sin perder dinero.', 'Quieres aprender electricidad, pero no sabes por dónde empezar.', 'Necesitas una guía organizada para consultar cuando estás estudiando o trabajando.'];
export function PainPoints() {
  return <section className="py-12 md:py-20 px-4 bg-white relative overflow-hidden border-y border-slate-200" data-id="element-161">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-163">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-50 text-red-600 rounded mb-6" data-id="element-164">
            <AlertTriangle size={32} strokeWidth={2} data-id="element-165" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-navy" data-id="element-166">
            ¿Te suena familiar?
          </h2>
        </motion.div>

        <div className="space-y-4 mb-10 md:mb-16" data-id="element-167">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-slate-50 p-5 md:p-6 rounded border border-slate-200 hover:border-red-200 transition-colors group" data-id="element-168">
              <div className="mt-1 bg-red-100 p-2 rounded shrink-0" data-id="element-169">
                <X size={20} className="text-red-600 stroke-[3px]" data-id="element-170" />
              </div>
              <p className="text-slate-700 font-semibold text-base md:text-lg leading-snug pt-1" data-id="element-171">
                {pain}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy p-8 md:p-12 rounded text-center shadow-2xl relative overflow-hidden border-b-4 border-electric" data-id="element-172">
          <div className="relative z-10" data-id="element-173">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-electric rounded mb-6 shadow-inner" data-id="element-174">
              <CheckCircle2 className="text-navy w-10 h-10" data-id="element-175" />
            </div>
            <h3 className="text-2xl md:text-4xl font-black text-white mb-4 leading-tight" data-id="element-176">
              Con el MEGA KIT ELECTRICISTA PRO™, todo eso se termina.
            </h3>
            <p className="text-electric font-bold text-lg md:text-2xl bg-white/10 inline-block px-6 py-2 rounded" data-id="element-177">
              La biblioteca técnica profesional, lista en tu celular.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}